import CREATE_MERGE_VERIFICATION_CODE from './createMergeVerificationCode.gql';
import MERGE_ACCOUNTS from './mergeAccounts.gql';
import ADD_SESSION from './addSession.gql';

export { CREATE_MERGE_VERIFICATION_CODE, MERGE_ACCOUNTS, ADD_SESSION };
